import { Alert, Button, Dialog, Paper } from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import { useEffect, useMemo, useRef, useState } from "react";
import * as auto_pi from "@crochik/auto-pi";

import { Loading } from "src/pi/ui/material/Loading";
import { UnknownValue } from "src/pi/ui/ObjectTypeDesigner/UnknownValue";
import { FieldTypeIcon } from "./FieldTypeIcon";
import { FormProvider } from "./useForm";
import { FormBuilder } from "./FormBuilder";

interface IFieldProps {
    field: auto_pi.Field;
}

function Field(props: IFieldProps) {
    const { field } = props;

    if (!field) return null;

    const title = `${field.Label ?? field.Name}${field.IsRequired ? " *" : ""}`;

    return (
        <Paper style={{
            margin: 4,
            width: "100%",
            height: "100%",
            // backgroundColor: ro ? "white" : "#eeeeee",
            minHeight: "60px",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            // border: ro ? "2px dotted lightgray" : undefined
        }} elevation={2}>
            <div
                style={{
                    padding: 6, display: "flex", flexDirection: "row", width: "100%"
                }}
            >
                <div style={{ width: 64, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FieldTypeIcon type={field._t} /></div>
                <div>
                    {title}
                    {field.Label !== field.Name && (<>
                        <br />
                        <span style={{ fontSize: "10pt" }}>{field.Name}</span>
                    </>)}
                    {field.DefaultValue && <div>Default: <UnknownValue value={field.DefaultValue} /></div>}
                    {/* {ft.initialValue && <div>Initial: <UnknownValue value={ft.initialValue} /></div>}
                    {ft.calculatedValue && <div>Calculated: <UnknownValue value={ft.calculatedValue} /></div>} */}
                </div>
            </div>
        </Paper>
    );
}

interface IFormDesignerProps {
    initialForm?: auto_pi.Form;
    onClose?(layouts: { [key: string]: auto_pi.FormLayout }): void;
}

export default function FormDesigner({ initialForm, onClose }: IFormDesignerProps) {
    const ref = useRef<HTMLDivElement>(null);

    const [error, setError] = useState<string>();
    // const [breakPoint, setBreakPoint] = useState<api.ScreenBreakpoint>();
    const [form, setForm] = useState<auto_pi.Form>();

    useEffect(() => {

        const formData = initialForm ?? {
            Name: "New Form",
            Fields: [],
            Layouts: {}
        };

        setForm(formData);

    }, [initialForm]);

    // ???
    const isVisible = useMemo(() => (field: auto_pi.Field) => {
        // if (roTypes[field._t]) {
        //     return false;
        // }
        return true;
    }, []);

    const onRender = (field: auto_pi.Field) => {
        if (!form || !field.Name) return null;

        return (
            <div className={css(styles.noClickContainer)}>
                <Field field={field} />
            </div>
        );
    };

    if (error) return (<Alert severity="error">{error}</Alert>);

    return (
        <div ref={ref} style={{ height: "100%", width: "100%" }}>
            {
                form ? (
                    <FormProvider form={form}>
                        <FormBuilder
                            isVisible={isVisible}
                            onRender={onRender}
                            onClose={onClose}
                        />
                    </FormProvider>
                ) : (
                    <Loading />
                )
            }
        </div>);
}

const styles = StyleSheet.create({
    noClickContainer: {
        pointerEvents: "none",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingTop: 4,
        paddingBottom: 4
    }, fieldTypeIcon: {
        width: "48px",
        height: "calc(100% - 16px)",
        backgroundColor: "rgb(240, 240, 240)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 12,
        marginBottom: 4,
        boxSizing: "border-box"
    }
});


interface IFormDesignerDialogProps extends IFormDesignerProps {
    onClose?(layouts: { [key: string]: auto_pi.FormLayout }): void;
}

export function FormDesignerDialog(props: IFormDesignerDialogProps) {
    const { onClose } = props;

    return (
        <Dialog open={true} fullScreen onClose={onClose}>
            <FormDesigner {...props} />
        </Dialog>
    );
}